module.exports = __webpack_public_path__ + "static/media/VIDEO-COUNT-2.0f0fb68c.png";